<div libFlexRow [libFlexRowGap]="'8px'">
	<ng-content></ng-content>
</div>
